import fp from "lodash/fp";

import { URLS } from "globalConstants";
import { history, store } from "helpers";
import { uiActions } from "store";
import { getIsOnline } from "store/ui/ui.reducer";

export function handleResponse(response) {
	return Promise.resolve(response.data);
}

export function handleError(error, errorHandler) {
	if (error.response && error.response.status === 401) {
		history.replace(URLS.logout);

		const errorText =
			error.response && error.response.data
				? error.response.data
				: error.message;
		return Promise.reject(errorText || "User unauthorized");
	}
	handleErrorIfNoConnection(error.response);

	if (errorHandler) {
		errorHandler(error);
	}

	const errorText =
		error.response && error.response.data
			? error.response.data
			: error.message;
	return Promise.reject(errorText || error);
}

export function handleErrorIfNoConnection(response) {
	const state = store.getState();
	const isOnline = getIsOnline(state);
	const status = fp.get("status", response);

	if (!isOnline) {
		store.dispatch(uiActions.showNoConnectionModal());
		return "No internet connection";
	} else if (fp.startsWith("5", status)) {
		store.dispatch(uiActions.showServerErrorModal(response));
		return "No connection to server";
	}
}
